(() => {
  const root = document.querySelector('.ingredient-guide');
  if (!root) return;
  const tabs = [...root.querySelectorAll('[data-guide-tab]')];
  const panels = [...root.querySelectorAll('[data-guide-panel]')];
  root.querySelector('.guide-tabs').setAttribute('role', 'tablist');
  const select = (tab, focus = false) => {
    tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
    panels.forEach(panel => { panel.hidden = '#' + panel.id !== tab.getAttribute('href'); });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
    tab.addEventListener('click', event => { event.preventDefault(); select(tab); });
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
    });
  });
  panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
  select(tabs.find(tab => tab.getAttribute('href') === location.hash) || tabs[0]);
})();
